import { ISystemParameterService } from "../../service/systemparameter/SystemParameterService";

export default class GetSystemParameterNumberInteractor {
  private systemParameterService: ISystemParameterService;

  constructor(systemParameterService) {
    this.systemParameterService = systemParameterService;
  }

  async execute(property: string) {
    return this.systemParameterService.getNumber(property);
  }
}
